{
    "ReportPortalInfo_UpgradeTo_Enterprise": "Aggiornare a Enterprise per accedere a questa funzione",
    "ReportPortalInfo_UpgradeTo_Enterprise_MST": "Aggiornamento a CXA Advanced per accedere a questa funzione",
    "ReportPortalInfo_UpgradeTo_Call Centre Supervisor": "Aggiornamento a Call Centre Supervisor per accedere a questa funzione.",
    "ReportPortalInfo_UpgradeTo_Call Centre Supervisor_MST": "Aggiornare a CXE Advanced per accedere a questa funzione.",
    "NAME": "ReportPortalInfo"
}